var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1a3 3 0 0 1 3 3v10a5 5 0 1 1-6 0V4a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v11.112l-.5.289a3 3 0 1 0 2.999 0L13 15.11V4a1 1 0 0 0-1-1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }